const envCodes = {
  prod: {
    fanCode: 'C000001',
    pumpCode: 'C000002',
    VFWaterSupplyCode: 'C000007',
    // 末端风口
    outletCode: 'C000012',
    speed: 'P000024',
    speedHigh: 'P000056',
    speedLow: 'P000057',
    fluid: 'P000007',
    wind: 'P000025',
    windHigh: 'P000051',
    windLow: 'P000048',
    head: 'P000008',
    npsh: 'P000012',
    pressure: 'P000026',
    pressureHigh: 'P000072',
    pressureLow: 'P000075',
    power: 'P000009',
    powerHigh: 'P000037',
    powerLow: 'P000038',
    efficiency: 'P000010',
    efficiencyHigh: 'P000060',
    efficiencyLow: 'P000061',
    noise: 'P000013',
    noiseHigh: 'P000058',
    noiseLow: 'P000059',
    length: 'P000014',
    width: 'P000015',
    height: 'P000016',
    weight: 'P000020',
    // 电机调速对应code和值信息
    electricSpeed: 'P000046',
    singleSpeed: 'V000032',
    doubleSpeed: 'V000033'
  }
}
const codes = envCodes.prod

export default codes
